export default __webpack_public_path__ + "static/media/graficachar.05e29d14.png";